import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { setRedirectPath } from 'actions';
import { useDispatch, useSelector } from 'Hooks';
import { useShoppingCart } from 'Components/ShoppingCartUniverse';

const useRedirectPath = () => {
  const shoppingCart = useShoppingCart();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state);
  const { pathname } = useLocation();
  const cartItems = shoppingCart.items.length > 0;
  
  useEffect(() => {
    if (user) {
      return;
    }

    const search = pathname.search(/signin|signup|verify-account/) < 0;
    if (!search) {
      return;
    }

    let redirectPath = '/';
    const index = pathname.search(/order/);
    const [, venueId] = pathname.slice(index).split('/');

    if (venueId && cartItems) {
      redirectPath = `/order/${venueId}`;
    } else if (venueId) {
      redirectPath = `/order/${venueId}`;
    }
    dispatch(setRedirectPath(redirectPath));
  }, [pathname, cartItems, user]);
};

export default useRedirectPath;
